import {
  organizationSchema,
  buildBreadcrumbSchema,
  buildGraph,
} from "../../../shared/utils/seoSchemas";

export const postersSeo = {
  title: "Posters Collection | Historical Project | Funooni",
  description:
    "Own historic, hand-signed limited edition posters from the Palestinian Posters Collection (1965-1990), authenticated and preserved on the blockchain by Funooni.",
  keywords: [
    "Palestinian posters",
    "historical posters",
    "limited edition art prints",
    "Ghazi Inaim",
    "Funooni",
    "historical project",
  ],
  canonicalUrl: "https://funooni.com/posters",
  robots: "index, follow",
  ogTitle: "Posters Collection | Funooni",
  ogDescription:
    "Historic Palestinian posters (1965-1990), hand-signed limited editions authenticated on the blockchain.",
  ogUrl: "https://funooni.com/posters",
  ogType: "website",
  twitterCard: "summary_large_image",
  structuredData: buildGraph(
    organizationSchema,
    buildBreadcrumbSchema([
      { name: "Home", url: "https://funooni.com/" },
      { name: "Historical Project", url: "https://funooni.com/reproduction" },
      { name: "Posters", url: "https://funooni.com/posters" },
    ]),
    {
      "@type": "CollectionPage",
      name: "Posters Collection",
      description:
        "Historic Palestinian posters (1965-1990), hand-signed limited editions authenticated on the blockchain.",
      url: "https://funooni.com/posters",
    },
  ),
};

export const physicalEditionSeo = {
  title: "Physical Editions | Historical Project | Funooni",
  description:
    "Collect restored historical photographs as framed or unframed physical prints, each paired with an authenticity NFT certificate. New monthly drop of 10 restored works.",
  keywords: [
    "physical editions",
    "restored photographs",
    "historical Palestine photography",
    "NFT certificate of authenticity",
    "Funooni",
    "historical project",
  ],
  canonicalUrl: "https://funooni.com/physical-editions",
  robots: "index, follow",
  ogTitle: "Physical Editions | Funooni",
  ogDescription:
    "Restored historical photographs available as framed or unframed prints with an included NFT certificate of authenticity.",
  ogUrl: "https://funooni.com/physical-editions",
  ogType: "website",
  twitterCard: "summary_large_image",
  structuredData: buildGraph(
    organizationSchema,
    buildBreadcrumbSchema([
      { name: "Home", url: "https://funooni.com/" },
      { name: "Historical Project", url: "https://funooni.com/reproduction" },
      {
        name: "Physical Editions",
        url: "https://funooni.com/physical-editions",
      },
    ]),
    {
      "@type": "CollectionPage",
      name: "Physical Editions",
      description:
        "Restored historical photographs available as framed or unframed prints with an included NFT certificate of authenticity.",
      url: "https://funooni.com/physical-editions",
    },
  ),
};
